import apiClient, { extractData } from '../api-client';

export const bestApi = {
  // Kho / điểm lấy hàng BEST.
  // KHÔNG có importShops: BEST không có API danh sách kho (khác GHN /shops và
  // GHTK /pick_add), nên mỗi kho do nhân viên khai tay ở tab BEST.
  listShops() {
    return apiClient.get('/best/shops').then(extractData);
  },
  createShop(data) {
    return apiClient.post('/best/shops', data).then(extractData);
  },
  updateShop(id, data) {
    return apiClient.put(`/best/shops/${id}`, data).then(extractData);
  },
  deleteShop(id) {
    return apiClient.delete(`/best/shops/${id}`);
  },
  setDefaultShop(id) {
    return apiClient.post(`/best/shops/${id}/set-default`).then(extractData);
  },

  /**
   * Phân tích địa chỉ free-text -> {province, ward, province_code, ward_code, source}.
   *
   * BEST không có API này; backend tự dò trong master data rồi fallback Gemini
   * (đúng cách GHN làm). LUÔN HTTP 200 — dò trượt thì `source: "none"` và mọi
   * field null, nhân viên vẫn chọn tay được.
   */
  parseAddress(address) {
    return apiClient.post('/best/parse-address', { address }).then(extractData);
  },

  /**
   * Báo phí theo ĐƠN, không theo địa chỉ rời — khác hẳn ghtkApi.calculateFee.
   * Backend cố ý nhận `order_id` để cân + địa chỉ báo phí luôn KHỚP cân + địa
   * chỉ sẽ nằm trong vận đơn. Gửi weight/province rời là mở lại đúng ca lệch:
   * màn hình báo một con phí, hãng trừ một con khác, chênh lệch shop gánh.
   *
   * Trả về BA trạng thái, không phải hai:
   *   { total: <số>, error: null }  -> phí hãng báo. `0` là MIỄN PHÍ THẬT.
   *   { total: null, error: "..." } -> KHÔNG BIẾT PHÍ (hãng từ chối/mạng hỏng).
   * Tuyệt đối đừng quy `null` về `0` khi hiển thị — nhân viên đọc "0đ" sẽ báo
   * khách được miễn phí ship.
   */
  calculateFee({ orderId, shopId = null, codAmount = null,
                 toProvinceName = null, toWardName = null, weightGrams = null }) {
    return apiClient
      .post('/best/calculate-fee', {
        order_id: orderId,
        shop_id: shopId,
        cod_amount: codAmount,
        // Địa chỉ/cân đang gõ trên popup — chưa lưu DB.
        to_province_name: toProvinceName,
        to_ward_name: toWardName,
        weight_grams: weightGrams,
      })
      .then(extractData);
  },

  /**
   * Nhãn vận đơn BEST, tối đa 50 mã/lần.
   * Backend PROXY file PDF về: link hãng trả là http:// nên đẩy link thô ra
   * trình duyệt sẽ bị chặn mixed-content khi CMS chạy https.
   */
  printLabels(codes) {
    return apiClient
      .post('/best/print-labels', { codes }, { responseType: 'blob' })
      .then((res) => res.data);
  },
};
